import React from "react";
import Banner from "../components/Banner/Banner";
import Header from "../components/Header/Header";
import Partners from "../components/PartnerSection/Partners";
import ROI from "../components/ROISection/ROI";
import Benefits from "../components/BenefitsSection/Benefits";
import SecondBanner from "../components/SecondBannerSection/SecondBanner";
import FAQ from "../components/FAQSection/FAQ";
import Footer from "../components/FooterSection/Footer";
import About from "../components/AboutSection/About";
import Solution from "../components/SolutionSection/Solution";
// import SeeDemo from "../components/SeeDemo/SeeDemo";
import Feature from "../components/FeatureSection/Feature";

export default function AIAviator() {
  return (
    <>
      <Header />
      {/*To use header component, you need to comment out the useEffect at line number 99 or provide section ids as mentioned in line number 13 */}
      <Banner />
      <Partners />
      <About />
      <Solution />
      <ROI />
      <Feature />
      {/*  */}
      <Benefits />
      {/* <SeeDemo /> */}
      <FAQ />
      <SecondBanner />
      <Footer />
    </>
  );
}
